<template>
  <v-container ref="test">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-row no-gutters  :class="(bookLang == 'en')?null:'rtlStyle'" v-if="uploadedBook">
      <v-col cols="12" md="3">
        <v-card
          style="overflow: auto; max-height: 600px"
          class="pa-2"
          elevation="0"
        >
          <v-treeview
            class="treeview"
            hoverable
            item-children="subitems"
            :items="Book.chapter"
            item-key="id"
            rounded
          >
            <template v-slot:prepend="{ item, open }">
              <v-icon
                class="mr-2 ml-2 iconChapter"
                v-if="item.subitems != 0 && item.subitems != undefined"
              >
                {{ open ? "mdi-folder-open" : "mdi-folder" }}
              </v-icon>

              <v-icon class="mr-2 ml-2 iconChapter" v-else>
                {{ (open = "mdi-link-variant") }}
              </v-icon>
              <a
                class="chapterLink labelChapter"
                v-if="!(item.subitems != 0 && item.subitems != undefined)"
                @click="returnHref(item.href)"
                >{{ item.label }}</a
              >
              <span class="labelChapter" v-else>{{ item.label }}</span>
            </template>
          </v-treeview>
        </v-card>
      </v-col>
      <v-col cols="12" md="9">
        <v-card class="pa-2" elevation="0">
          <div
            ref="bookElement"
            id="viewer"
            style="position: relative; top: -8px"
            class="spreads"
          >
            <v-btn
              style="position: absolute; right : 5px"
              class="mx-2 btnClass"
              fab
              dark
              small
              color="primary"
              @click="nextPage()"
            >
              <v-icon dark> mdi-arrow-right-bold </v-icon>
            </v-btn>

            <v-btn
              style="position: absolute; left : 5px ;"
              class="mx-2 btnClass"
              fab
              dark
              small
              color="primary"
              @click="prevPage()"
            >
              <v-icon dark> mdi-arrow-left-bold </v-icon>
            </v-btn>

          </div>

          <div class="btmContainer text-center">
            <h3 class="pageNumberStyle">
              {{ pageNO + 1 }}
            </h3>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-card class="pa-2" elevation="0" v-else>
      <v-skeleton-loader
        type="table-heading, list-item-two-line, image, table-tfoot"
      ></v-skeleton-loader>
    </v-card>
  </v-container>
</template>

<style>
.btnClass{
  position: absolute;
  top: 0;
  z-index: 4;
  top: 200px;
}
.chapterLink {
  color: blue;
  text-decoration: none;
  font-weight: 400;
}
.rtlStyle {
  direction: rtl;
}
.labelChapter {
  width: calc(100% - 40px);
  display: flex;
  float: left;
  position: relative;
  font: status-bar;
  line-height: 20px;
}
.treeview .v-treeview-node.v-treeview-node--rounded .v-treeview-node__root {
  min-height: 23px;
}
.pageNumberStyle {
  background-color: #3e2723;
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  position: absolute;
  bottom: 100px;
  left: 20px;
  color: white;
  font-size: 12px;
}
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 0px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #3e2723;
  border-radius: 0px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #3e2723;
}
@media only screen and (max-width: 414px) {
  .pageNumberStyle {
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    font-weight: 400;
  }
  ::-webkit-scrollbar {
    width: 0px !important
  }
  .btnClass:last-of-type{
    left: -20px !important
  }
  .btnClass:first-of-type{
    right: -22px !important
  }
}
</style>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import Book from "epubjs";

export default {
  data() {
    return {
      pageNO: 1,
      bookLang : 'en' ,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Books",
          disabled: false,
          to: "/books",
        },
        {
          text: "Read Book",
          disabled: true,
        },
      ],

      Book: {
        BookObj: null,
        rendition: null,
        url: "",
        chapter: [],
        versionInfo: "",
      },
      hrefLink: "",

      uploadedBook: false,
    };
  },
  computed: {},
  watch: {
    hrefLink: function (val) {
      this.Book.rendition.display(val);
    },
  },
  components: {
    Breadcrumbs,
  },
  mounted() {
    this.getVersionInfo();
    
  },
  methods: {
    getVersionInfo() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/book/" +
            this.$route.params.bookID +
            "/version/" +
            this.$route.params.versionID
        )
        .then((response) => {
          
          this.versionInfo = response.data.data;
          this.bookLang = this.versionInfo.metainfo[0]['meta_value'] 
          this.Book.url = this.versionInfo.url;
          this.getBook();
        })
        .catch((error) => {
          this.$store.dispatch("PushErrorMsg", error.data.data);
          this.uploadedBook = true;
        });
    },

    getBook() {
      this.Book.BookObj = new Book(this.Book.url);
      this.Book.rendition = this.Book.BookObj.renderTo("viewer", {
        flow: "scrolled-doc",
        width: "100%",
        spread: "always",
        minSpreadWidth: "100%",
      });

      //this.Book.rendition.direction ("rtl")

      this.Book.rendition.direction("rtl");
      this.Book.rendition.display();
      this.Book.BookObj.loaded.navigation.then((nav) => {
        this.uploadedBook = true;
        this.Book.chapter = nav.toc;
      });

      this.Book.rendition.hooks.content.register(this.UpdateBookContent);

      // let pageNO = this.pageNO
      this.Book.rendition.on("locationChanged", this.showPageNot);
    },
    showPageNot(location) {
      this.pageNO = location.index;
    },
    UpdateBookContent (contents){
      this.loadingAdd = true;
      let DataForm = {
          Param: {
            bookID: this.$route.params.bookID,
            versionID: this.$route.params.versionID,
            HTMLcontent: contents.content.innerHTML,
          },
          API: "/admin/microprocess",
        };
      this.$store
          .dispatch("PostToAPI", DataForm)
          .then((response) => {
            this.loadingAdd = false;
            if (response.data.success == true){
              //console.log (response.data.data.HTMLcontent)
              contents.content.innerHTML = response.data.data.HTMLcontent
            }
            console.log(this.$refs.bookElement.getElementsByTagName('iframe')[0].setAttribute("class", "democlass"))          
          })
          .catch(() => {
            this.loadingAdd = false;
          });
    },
    nextPage() {
      this.Book.rendition.next();
    },
    prevPage() {
      this.Book.rendition.prev();
    },
    returnHref(val) {
      this.hrefLink = val;
      
    },
  },
};
</script>